// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"7867":"previewbar","8652":"vitatree"}[chunkId] + ".css";
};